import "./types"

const lastRequestAtTime = (): string =>
  ((new Date().getTime() / 1000) | 0).toString()

export const boot = (userId: string, email: string, jwt: string): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("boot", {
      app_id: window.intercomSettings?.app_id,
      user_id: userId,
      email,
      intercom_user_jwt: jwt,
      last_request_at: lastRequestAtTime(),
    })
  }
}

export const refresh = (): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("update", {
      last_request_at: lastRequestAtTime(),
    })
  }
}

export const show = (): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("show")
  }
}

export const showMessages = (): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("showMessages")
  }
}

export const hideLauncher = (): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("update", {
      hide_default_launcher: true,
    })
  }
}

export const showLauncher = (): void => {
  if (typeof window.Intercom !== "undefined") {
    window.Intercom("update", {
      hide_default_launcher: false,
    })
  }
}
